<template>
  <!-- the phone table's headline chance: our %, a bar under it coloured by value, the add button in its own column -->
  <span class="prop-headline flex items-center tabular-nums" :class="toneClass" :title="price && !locked ? title : null">
    <span class="w-[44px] flex-none flex flex-col items-center gap-1">
      <span class="text-[14px] leading-none font-semibold" :class="{ 'blur-sm select-none text-gray-500': locked && price }">{{
        main
      }}</span>
      <span v-if="price" class="block w-8 h-1 rounded-full bg-black/10 overflow-hidden" aria-hidden="true">
        <span class="block h-full rounded-full meter" :style="{ width: (locked ? 0 : Math.round(price.p)) + '%' }"></span>
      </span>
    </span>
    <span class="w-[22px] flex-none flex justify-end">
      <AddPill v-if="price" :selection="selection" />
    </span>
  </span>
</template>

<script>
import PropTile from "./PropTile.vue";

export default {
  name: "PropHeadline",
  extends: PropTile,
  props: {
    label: { type: String, default: "" },
  },
  computed: {
    // always our %, whatever the desktop Show switch says: odds and value are in the drop-down
    view() {
      return "pct";
    },
  },
};
</script>

<style scoped>
.tone-value { color: #16a34a; }
.tone-value .meter { background: #22c55e; }
.tone-poor { color: #9f1239; }
.tone-poor .meter { background: #f87171; }
.tone-neutral { color: #1f2937; }
.tone-neutral .meter { background: #9ca3af; }
.tone-none { color: #9ca3af; }
html.dark .tone-value { color: #86efac; }
html.dark .tone-poor { color: #fca5a5; }
html.dark .tone-neutral { color: #e5e7eb; }
</style>
